import { Box, styled, Typography, Divider, Button } from "@mui/material"
import { colors } from "../../../theme/colors"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const TopContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
})

export const SourceDescription = styled(Typography)({
  marginTop: 20,
  color: colors.lightBlack,
  fontSize: 18,
  lineHeight: "24px",
})

export const Amount = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 42,
  lineHeight: "56px",
})

export const TransactionTime = styled(Typography)({
  color: colors.darkGrey,
  fontSize: 14,
  lineHeight: "18px",
})

export const StyledDivider = styled(Divider)({
  color: colors.darkGrey,
  marginTop: 40,
  marginBottom: 20,
  border: "2px dotted",
  borderTop: "none",
})

export const DetailsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 20,
})

export const DetailContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
})

export const DetailLabel = styled(Box)({
  color: colors.darkGrey,
  fontSize: 14,
  lineHeight: "18px",
})

export const DetailValue = styled(Box)({
  color: colors.lightBlack,
  fontSize: 18,
  lineHeight: "24px",
})

export const StyledButton = styled(Button)({
  marginTop: "auto",
})
